import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f8cf830c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "my-5 nes-container with-title text-xs" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "flex flex-row" }
const _hoisted_4 = ["alt", "src"]
const _hoisted_5 = { class: "ml-5 text-gray-400" }
const _hoisted_6 = {
  key: 0,
  class: "bg-blue-100 text-black p-2 inline-block"
}
const _hoisted_7 = {
  key: 1,
  class: "bg-yellow-100 text-black p-2 inline-block"
}
const _hoisted_8 = {
  key: 2,
  class: "bg-gray-100 text-gray-700 p-2 inline-block"
}
const _hoisted_9 = {
  key: 3,
  class: "mt-2 text-black flex"
}
const _hoisted_10 = {
  key: 0,
  class: "bg-rarity-legendary p-2 inline-block"
}
const _hoisted_11 = {
  key: 1,
  class: "bg-rarity-epic p-2 inline-block"
}
const _hoisted_12 = {
  key: 2,
  class: "bg-rarity-rare p-2 inline-block"
}
const _hoisted_13 = {
  key: 3,
  class: "bg-rarity-uncommon p-2 inline-block"
}
const _hoisted_14 = {
  key: 4,
  class: "bg-rarity-common p-2 inline-block"
}
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" About: ")
const _hoisted_16 = { class: "text-black" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" Mint: ")
const _hoisted_18 = { class: "text-black" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Address: ")
const _hoisted_20 = { class: "text-black" }
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" Owner: ")
const _hoisted_22 = { class: "text-black" }
const _hoisted_23 = { class: "flex" }
const _hoisted_24 = {
  key: 0,
  class: "bg-gray-200 mt-5 copy-father"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_QuestionMark = _resolveComponent("QuestionMark")!
  const _component_vue_json_pretty = _resolveComponent("vue-json-pretty")!
  const _component_ContentTooltipJSON = _resolveComponent("ContentTooltipJSON")!
  const _component_ModalWindow = _resolveComponent("ModalWindow")!
  const _component_ContentTooltipRarity = _resolveComponent("ContentTooltipRarity")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.n.metadataExternal.name) + " " + _toDisplayString(_ctx.n.metadataExternal.symbol ? '/' : '') + " " + _toDisplayString(_ctx.n.metadataExternal.symbol), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("img", {
        alt: _ctx.n.mint,
        src: _ctx.n.metadataExternal.image
      }, null, 8, _hoisted_4),
      _createElementVNode("div", _hoisted_5, [
        (_ctx.n.editionType && _ctx.isMaster(_ctx.n.editionType))
          ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_ctx.n.editionType), 1))
          : (_ctx.n.editionType)
            ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.n.editionType) + " #" + _toDisplayString(_ctx.n.editionData.edition), 1))
            : (_openBlock(), _createElementBlock("p", _hoisted_8, "Edition Unknown")),
        (_ctx.n.rarityScore)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              (_ctx.n.rarityCategory === 'legendary')
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, " Legendary (Top 1%) / Rank: " + _toDisplayString(_ctx.n.rarityRank + 1) + " / Score: " + _toDisplayString(parseInt(_ctx.n.rarityScore)), 1))
                : (_ctx.n.rarityCategory === 'epic')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, " Epic (Top 5%) / Rank: " + _toDisplayString(_ctx.n.rarityRank + 1) + " / Score: " + _toDisplayString(parseInt(_ctx.n.rarityScore)), 1))
                  : (_ctx.n.rarityCategory === 'rare')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, " Rare (Top 20%) / Rank: " + _toDisplayString(_ctx.n.rarityRank + 1) + " / Score: " + _toDisplayString(parseInt(_ctx.n.rarityScore)), 1))
                    : (_ctx.n.rarityCategory === 'uncommon')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_13, " Uncommon (Top 40%) / Rank: " + _toDisplayString(_ctx.n.rarityRank + 1) + " / Score: " + _toDisplayString(parseInt(_ctx.n.rarityScore)), 1))
                      : (_openBlock(), _createElementBlock("div", _hoisted_14, " Common / Rank: " + _toDisplayString(_ctx.n.rarityRank + 1) + " / Score: " + _toDisplayString(parseInt(_ctx.n.rarityScore)), 1)),
              _createVNode(_component_QuestionMark, {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showModal('tooltipRarity'))),
                class: "ml-2 mt-2"
              })
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("p", null, [
          _hoisted_15,
          _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.n.metadataExternal.description), 1)
        ]),
        _createElementVNode("p", null, [
          _hoisted_17,
          _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.n.mint), 1)
        ]),
        _createElementVNode("p", null, [
          _hoisted_19,
          _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.n.address ?? _ctx.NOT_FOUND), 1)
        ]),
        _createElementVNode("p", null, [
          _hoisted_21,
          _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.n.splTokenInfo ? _ctx.n.splTokenInfo.owner : _ctx.NOT_FOUND), 1)
        ]),
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("button", {
            class: "nes-btn is-primary",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleJSON && _ctx.toggleJSON(...args)))
          }, "{ full JSON }"),
          _createVNode(_component_QuestionMark, {
            class: "text-base ml-2 mt-2",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showModal('tooltipJSON')))
          })
        ])
      ])
    ]),
    (_ctx.fullJSON)
      ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
          _createElementVNode("button", {
            class: "nes-btn is-primary copy",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.doCopyJSON(_ctx.n)))
          }, _toDisplayString(_ctx.copyText), 1),
          _createVNode(_component_vue_json_pretty, {
            class: "text-xs",
            data: _ctx.stringifyPubkeysAndBNsInObject(_ctx.n)
          }, null, 8, ["data"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isModalVisible('tooltipJSON'))
      ? (_openBlock(), _createBlock(_component_ModalWindow, {
          key: 1,
          title: "What's this JSON?",
          onHideModal: _cache[4] || (_cache[4] = ($event: any) => (_ctx.hideModal('tooltipJSON')))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ContentTooltipJSON)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.isModalVisible('tooltipRarity'))
      ? (_openBlock(), _createBlock(_component_ModalWindow, {
          key: 2,
          title: "What is Rarity Score?",
          onHideModal: _cache[5] || (_cache[5] = ($event: any) => (_ctx.hideModal('tooltipRarity')))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ContentTooltipRarity)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}